import api from './api';
export const userCompanyApi = {
  // 获取用户关联的公司列表
  getUserCompanies: userId => {
    return api.get(`/api/users/${userId}/companies`);
  },
  // 设置当前用户的默认公司
  setCurrentCompany: (userId, companyId) => {
    return api.post(`/api/user/set-current-company`, {
      company_id: companyId
    });
  },
  // 批量添加用户与公司的关联
  attachCompanies: (userId, companyIds) => {
    return api.post(`/api/users/${userId}/attach-companies`, {
      company_ids: companyIds
    });
  },
  // 批量移除用户与公司的关联
  detachCompanies: (userId, companyIds) => {
    return api.post(`/api/users/${userId}/detach-companies`, {
      company_ids: companyIds
    });
  },
  // 同步用户与公司的关联（覆盖）
  syncCompanies: (userId, companyIds) => {
    return api.post(`/api/users/${userId}/sync-companies`, {
      company_ids: companyIds
    });
  },
  // 获取公司下的所有用户
  getCompanyUsers: companyId => {
    return api.get(`/api/companies/${companyId}/users`);
  },
  // 添加单个用户与公司的关联
  attachCompany: (userId, companyId) => {
    return api.post(`/api/users/${userId}/attach-company`, {
      company_id: companyId
    });
  },
  // 移除单个用户与公司的关联
  detachCompany: (userId, companyId) => {
    return api.post(`/api/users/${userId}/detach-company`, {
      company_id: companyId
    });
  }
};
export default userCompanyApi;